import * as React from 'react';
import SVG from 'react-inlinesvg';
import { Button } from '__common/components/Button';
import { connect } from 'react-redux';
import { MOVE_ARRAY_MODE_DISABLE, RESTORE_PANELS_FOR_NO_MOVEMENT, ENABLE_ARRAY_NUMBER_FEATURE, DISABLE_ARRAY_NUMBER_FEATURE } from 'actions';
import autobind from 'autobind-decorator';

type Props = {
  enableArrayNumbering: () => void;
  disableArrayNumbering: () => void;
  disableMoveArray: () => void;
  moveArrayEnabled: boolean,
  showArrayNumber: boolean,
}

class ToggleArrayNumber extends React.Component<Props, toggleArrayNumberState> {
  @autobind
  toggleArrayNumbering() {
    const { moveArrayEnabled, disableMoveArray, enableArrayNumbering } = this.props;
    if (moveArrayEnabled) {
      disableMoveArray();
    }

    enableArrayNumbering();
  }

  render() {
    const { showArrayNumber, disableArrayNumbering } = this.props;
    return (
      <Button
        variant="text"
        onClick={!showArrayNumber ? this.toggleArrayNumbering : disableArrayNumbering}
        className={`roofs-selector-button${showArrayNumber ? ' roofs-selector-control-panel-active' : ''}`}
        tooltipLabel="Show Array Number"
      >
        <SVG className={showArrayNumber ? 'roofs-selector-control-panel-active' : ''} src={require('assets/media/icons/array-numbering-icon-2.svg')} />
      </Button>
    );
  }
}

function mapStateToProps(state: appState) {
  return {
    moveArrayEnabled: state.background.moveArrayMode,
    showArrayNumber: state.background.showArrayNumber,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    disableMoveArray: () => {
      dispatch(RESTORE_PANELS_FOR_NO_MOVEMENT());
      dispatch(MOVE_ARRAY_MODE_DISABLE());
    },
    enableArrayNumbering: () => dispatch(ENABLE_ARRAY_NUMBER_FEATURE()),
    disableArrayNumbering: () => dispatch(DISABLE_ARRAY_NUMBER_FEATURE()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleArrayNumber);